import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/Player/Get', params)
    },
    getList: params => {
        return API.GET('/api/Player/List', params)
    },
    getListAdmin: params => {
        return API.GET('/api/Player/ListAdmin', params)
    },
    select: params => {
        return API.GET('/api/Player/select', params)
    },
    adminSelect:params=>{
        return API.GET('/api/Player/AdminSelect',params);
    },
    add: params => {
        return API.POST('/api/Player/Add', params)
    },
    edit: params => {
        return API.POST('/api/Player/Edit', params)
    },
    addAdmin: params => {
        return API.POST('/api/Player/AddAdmin', params)
    },
    editAdmin: params => {
        return API.POST('/api/Player/EditAdmin', params)
    },
    delete: params => {
        return API.DELETE('/api/Player/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/Player/DeleteBatch', params)
    },
    validate: params => {
        return API.POST('/api/Player/validate', params)
    },
    validateHouseHold: params => {
        return API.POST('/api/Player/ValidateHouseHold', params)
    },
    upload: params => {
        return API.POSTFORM('/api/Player/Upload', params)
    }, import: params => {
        return API.POSTFORM('/api/Player/Import', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/player.js